import React from 'react';
import {withRouter} from 'react-router-dom';
import 'moment/locale/fr';
import {Alert, Buttons, Form, Typography, Inputs} from 'components';
import {useForm} from 'hooks';

import {makeStyles} from '@material-ui/styles';
import {Box} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(2, 0)
    },
    title: {
        paddingBottom: theme.spacing(2)
    },
    box: {
        padding: theme.spacing(1, 2),
        margin: theme.spacing(1, 0),
        borderRadius: 5,
        color: theme.palette.blue,
        border: `solid 1px ${theme.palette.blue}`
    },
    label: {
        width: 255
    }
}));

const Document = () => {
    const {formState} = useForm();
    const classes = useStyles();
    const documents = {
        s2e: {
            label: 'Bulletin_de_transfert_individuel_ES.pdf',
            url: 'transfer/Bulletin_de_transfert_individuel_ES.pdf',
            size: '230 Ko'
        },
        ais: {
            label: 'Formulaire_de_transfert_individuel_contrat_retraite_vers_PERECO_ou_PERECO-I.pdf',
            url: 'transfer/Formulaire_de_transfert_individuel_contrat_retraite_vers_PERECO_ou_PERECO-I.pdf',
            size: '230 Ko'
        }
    };
    if (!formState.values.scope) return null;
    return (
        <Box mt={5}>
            <Box>
                <Typography
                    variant="h4"
                    semibold
                    color="blue"
                >
                    Demande de transfert vers votre Epargne salariale AXA{' '}
                </Typography>
            </Box>
            <Box mt={3}>
                <Typography
                    variant="h5"
                    color="blue"
                >
                    1 - Téléchargez, complétez et imprimez le document suivant
                </Typography>
                <Buttons.Download
                    label={documents[formState.values.scope].label}
                    size={documents[formState.values.scope].size}
                    url={`${process.env.PUBLIC_URL}/docs/${documents[formState.values.scope].url}`}
                />
            </Box>
            <Box mt={3}>
                <Typography
                    variant="h5"
                    color="blue"
                >
                    2 - Envoyez le document à l’adresse suivante
                </Typography>
                <Box className={classes.box}>
                    <Typography
                        variant="h5"
                        color="blue"
                        center
                        semibold
                    >
                        AXA Épargne Entreprise <br />
                        TSA 60032
                        <br />
                        93736 Bobigny Cedex 9<br />
                        France
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

function TransferS2E({history}) {
    const classes = useStyles();

    return (
        <>
            <Alert
                title={'Information : vous pouvez transférer votre épargne dans le cas suivant'}
                severity="info"
                message={
                    <Box
                        ml={1}
                        mt={2}
                    >
                        <ul>
                            <li>
                                De votre <b>Epargne Salariale actuelle vers votre Epargne Salariale AXA</b>, à condition
                                que la durée minimale d'indisponibilité des sommes soit équivalente dans le plan
                                d'origine et dans le nouveau.{' '}
                            </li>
                        </ul>
                    </Box>
                }
            />
            <Box mt={5}>
                <Typography
                    variant="h4"
                    color="blue"
                    semibold
                >
                    Je souhaite transférer vers mon épargne salariale AXA mon actuelle épargne
                </Typography>
            </Box>
            <Form>
                <Inputs.RadioButton
                    name="scope"
                    options={[
                        {
                            label: 'Salariale (PEE,PEEG,PEI)',
                            value: 's2e'
                        },
                        {
                            label: 'Retraite (PER,PERP,PERECO)',
                            value: 'ais'
                        }
                    ]}
                    classNameLabel={classes.label}
                />
                <Document />
            </Form>
        </>
    );
}

export default withRouter(TransferS2E);
